import Refluxr from '../../lib/refluxr';
import { OnlineApi } from '../services';
let container = require('../core/container');

function SettingsActions() {
   var Actions = Refluxr.createActions([
      'setPeopleLastRouteSync',
      {
         fetchAppSettings: OnlineApi.query,
         prepare: function () {
            return {
               messageType: 'FETCH_APPSETTINGS'
            };
         }
      },
      'setTaskObserveLastRouteSync',
      {
         getAccountSettings: OnlineApi.query,
         prepare: function () {
            return {
               messageType: 'GET_ACCOUNTSETTING'
            };
         }
      },
      {
         addPriority: OnlineApi.send,
         prepare: function (args) {
            return {
               messageType: 'ADD_PRIORITY',
               name: args.name,
               color: args.color,
               resolutionTargetMins: args.resolutionTargetMins == null ? null : args.resolutionTargetMins
            };
         }
      },
      {
         deletePriority: OnlineApi.send,
         prepare: function (args) {
            return {
               messageType: 'DELETE_PRIORITY',
               noPriority: args.noPriority
            };
         }
      },
      {
         reorderPriorities: OnlineApi.send,
         prepare: function (args) {
            return {
               messageType: 'REORDER_PRIORITIES',
               orderedPriorityNos: args.orderedPriorityNos
            };
         }
      },
      {
         updatePriority: OnlineApi.send,
         prepare: function (args) {
            return {
               messageType: 'UPDATE_PRIORITY',
               noPriority: args.noPriority,
               name: args.name,
               color: args.color,
               resolutionTargetMins: args.resolutionTargetMins == null ? null : args.resolutionTargetMins
            };
         }
      },
      {
         addTaskType: OnlineApi.send,
         prepare: function (args) {
            return {
               messageType: 'ADD_TASKTYPE',
               name: args.name
            };
         }
      },
      {
         deleteTaskType: OnlineApi.send,
         prepare: function (args) {
            return {
               messageType: 'DELETE_TASKTYPE',
               noTaskType: args.noTaskType
            };
         }
      },
      {
         updateTaskType: OnlineApi.send,
         prepare: function (args) {
            return {
               messageType: 'UPDATE_TASKTYPE',
               noTaskType: args.noTaskType,
               name: args.name
            };
         }
      }
   ]);
   return Actions;
}

SettingsActions.instance = new SettingsActions();

export default SettingsActions.instance;
